import styles from '@components/Preloader/Preloader.styles';
type PropsType = {
  text?: string;
};
const Preloader = ({
  text
}: PropsType) => {
  return <div sx={styles.preloaderContainer}>
      {text && <div sx={styles.preloaderText}> {text}</div>}
      <div sx={styles.preloader} />
    </div>;
};
export default Preloader;